(() => {
  const api = 'https://shopify-orders-api.ecodereality.workers.dev/api';
  const diagramLabels = {
    en: 'View in diagram', lt: 'Žiūrėti schemoje', de: 'Im Diagramm ansehen',
    fr: 'Voir sur le schéma', es: 'Ver en el diagrama', it: 'Vedi nello schema',
    pl: 'Zobacz na schemacie', ru: 'Посмотреть на схеме', uk: 'Переглянути на схемі',
    bg: 'Виж в схемата', cs: 'Zobrazit ve schématu', da: 'Se i diagrammet',
    el: 'Προβολή στο διάγραμμα', fi: 'Näytä kaaviossa', hr: 'Prikaži na dijagramu',
    hu: 'Megtekintés az ábrán', id: 'Lihat pada diagram', ja: '図で見る', ko: '도면에서 보기',
    nb: 'Se i diagrammet', no: 'Se i diagrammet', nl: 'Bekijk in diagram',
    pt: 'Ver no diagrama', ro: 'Vezi în diagramă', sk: 'Zobraziť v schéme',
    sl: 'Prikaži na shemi', sv: 'Visa i diagrammet', th: 'ดูในแผนภาพ',
    tr: 'Şemada görüntüle', vi: 'Xem trong sơ đồ', zh: '在图中查看', 'zh-tw': '在圖中查看'
  };
  function diagramLabel() {
    const lang = (document.documentElement.lang || 'en').toLowerCase();
    return diagramLabels[lang] || diagramLabels[lang.split('-')[0]] || diagramLabels.en;
  }
  const feedbackLabels = {
    en: ['Successfully added', 'Error'], lt: ['Sėkmingai pridėta', 'Klaida'], de: ['Erfolgreich hinzugefügt', 'Fehler'],
    fr: ['Ajouté avec succès', 'Erreur'], es: ['Añadido correctamente', 'Error'], it: ['Aggiunto con successo', 'Errore'],
    pl: ['Dodano pomyślnie', 'Błąd'], ru: ['Успешно добавлено', 'Ошибка'], uk: ['Успішно додано', 'Помилка'],
    bg: ['Успешно добавено', 'Грешка'], cs: ['Úspěšně přidáno', 'Chyba'], da: ['Tilføjet', 'Fejl'],
    el: ['Προστέθηκε επιτυχώς', 'Σφάλμα'], fi: ['Lisätty onnistuneesti', 'Virhe'], hr: ['Uspješno dodano', 'Pogreška'],
    hu: ['Sikeresen hozzáadva', 'Hiba'], id: ['Berhasil ditambahkan', 'Kesalahan'], ja: ['追加しました', 'エラー'],
    ko: ['추가되었습니다', '오류'], nb: ['Lagt til', 'Feil'], no: ['Lagt til', 'Feil'],
    nl: ['Succesvol toegevoegd', 'Fout'], pt: ['Adicionado com sucesso', 'Erro'], ro: ['Adăugat cu succes', 'Eroare'],
    sk: ['Úspešne pridané', 'Chyba'], sl: ['Uspešno dodano', 'Napaka'], sv: ['Tillagd', 'Fel'],
    th: ['เพิ่มสำเร็จแล้ว', 'ข้อผิดพลาด'], tr: ['Başarıyla eklendi', 'Hata'], vi: ['Đã thêm thành công', 'Lỗi'],
    zh: ['已成功添加', '错误'], 'zh-tw': ['已成功新增', '錯誤']
  };
  const feedbackLang = (document.documentElement.lang || 'en').toLowerCase();
  const feedbackText = feedbackLabels[feedbackLang] || feedbackLabels[feedbackLang.split('-')[0]] || feedbackLabels.en;
  function chooseQuantity(section, code, maximum, trigger) {
    return new Promise(resolve => {
      const dialog = document.createElement('dialog'); dialog.className = 'rr-quantity-dialog';
      const form = document.createElement('form'); form.method = 'dialog';
      const header = document.createElement('div'); header.className = 'rr-quantity-header';
      const title = document.createElement('h2'); title.textContent = section.dataset.quantity || 'Quantity';
      dialog.setAttribute('aria-label', `${title.textContent}: ${code}`);
      const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.className = 'rr-quantity-close';
      close.setAttribute('aria-label', section.dataset.close || 'Close'); close.title = close.getAttribute('aria-label');
      close.addEventListener('click', () => dialog.close()); header.append(title, close);
      const part = document.createElement('p'); part.textContent = code;
      const label = document.createElement('label'); label.className = 'rr-managed-quantity'; label.textContent = `1–${maximum}`;
      const input = document.createElement('input'); input.type = 'number'; input.min = '1'; input.max = String(maximum); input.step = '1'; input.value = '1'; input.required = true;
      input.setAttribute('aria-label', `${title.textContent} (1–${maximum})`); label.append(input);
      const submit = document.createElement('button'); submit.type = 'submit'; submit.className = 'rr-quantity-confirm'; submit.textContent = section.dataset.add || 'Add to cart';
      let selected = null;
      form.addEventListener('submit', event => {
        event.preventDefault();
        if (!input.reportValidity()) return;
        selected = Number(input.value); dialog.close();
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { dialog.remove(); trigger.focus(); resolve(selected); }, { once: true });
      form.append(header, part, label, submit); dialog.append(form); document.body.append(dialog); dialog.showModal(); input.focus(); input.select();
    });
  }
  let photos = {};
  // Catalog detail views copy HTML, so per-button listeners do not survive.
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.pvc-real-photo-btn');
    if (!button || typeof window.pvcOpenPartPhoto !== 'function') return;
    event.preventDefault();
    event.stopPropagation();
    window.pvcOpenPartPhoto(button);
  }, true);
  const find = code => photos[code] || photos[String(code).split('-')[0]] || [];
  const lookup = fetch(`${api}/part-photos`, { cache: 'no-store' }).then(r => { if (!r.ok) throw new Error('Photo lookup failed'); return r.json(); }).then(data => {
    photos = data.items || {};
    Object.keys(photos).forEach(code => { const base = code.split('-')[0]; if (!photos[base]) photos[base] = photos[code]; });
    window.rrLivePartPhotos = photos;
    return photos;
  });
  function refreshPhotos() {
    document.querySelectorAll('td[data-label="Code"]').forEach(cell => {
      const code = (cell.querySelector('.pvc-code-text')?.textContent || '').trim();
      const list = find(code);
      if (!list.length || cell.querySelector('.pvc-real-photo-btn')) return;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'pvc-real-photo-btn'; button.dataset.code = code;
      button.dataset.title = cell.closest('tr')?.querySelector('td[data-label="Name"]')?.textContent || '';
      button.setAttribute('aria-label', `Open real part photo for ${code}`);
      button.appendChild(document.createElement('img'));
      cell.appendChild(button);
    });
    document.querySelectorAll('.pvc-real-photo-btn[data-code]').forEach(button => {
      const list = find(button.dataset.code); if (!list.length) return;
      const value = JSON.stringify(list); if (button.dataset.photos === value) return;
      button.dataset.photos = value;
      const img = button.querySelector('img'); if (img) img.src = list[0].thumb || list[0].url;
    });
  }
  lookup.then(() => {
    refreshPhotos(); let pending = false;
    new MutationObserver(() => { if (!pending) { pending = true; requestAnimationFrame(() => { pending = false; refreshPhotos(); }); } }).observe(document.body, { childList: true, subtree: true });
  }).catch(console.warn);
  const pages = { 'MY JUNIPER': 'tesla-model-y-juniper-2025-feb-eu', 'MY': 'tesla-model-y-2020-2025-europe', 'M3': 'tesla-model-3-2017-2023-eu', 'M3 HIGHLAND': 'tesla-model-3-highland-2023-eu', 'MS 2012 2016': 'tesla-model-s-2012-2016-eu', 'MS 2016 2021': 'tesla-model-s-2016-2021-eu', 'MS 2021 FEB': 'tesla-model-s-2021-eu', 'MX 2015 2021': 'tesla-model-x-2015-2021-eu', 'MX 2021 2025': 'tesla-model-x-2021-2025-eu' };
  const modelNames = { 'MY JUNIPER': 'MY Juniper', MY: 'MY 2020-2024', M3: 'Model 3 2017-2023', 'M3 HIGHLAND': 'Model 3 Highland', 'MS 2012 2016': 'Model S 2012-2016', 'MS 2016 2021': 'Model S 2016-2021', 'MS 2021 FEB': 'Model S 2021+', 'MX 2015 2021': 'Model X 2015-2021', 'MX 2021 2025': 'Model X 2021-2025' };
  function modelGroup(section, tag) {
    const group = document.createElement('section'); group.className = 'rr-model-group';
    const header = document.createElement('div'); header.className = 'rr-model-heading';
    const heading = document.createElement('h2'); heading.textContent = `Popular Tesla ${modelNames[tag]} Parts`; header.append(heading);
    const controls = document.createElement('div'); controls.className = 'rr-model-controls';
    const grid = document.createElement('div'); grid.setAttribute('data-managed-grid', ''); grid.className = 'rr-model-carousel'; grid.tabIndex = 0; grid.setAttribute('aria-label', heading.textContent);
    const buttons = [-1, 1].map(direction => {
      const button = document.createElement('button'); button.type = 'button';
      const label = direction < 0 ? section.dataset.previous : section.dataset.next; button.title = label; button.setAttribute('aria-label', label);
      button.append(section.querySelector('[data-diagram-icon]').content.cloneNode(true));
      if (direction < 0) button.className = 'rr-model-prev';
      button.addEventListener('click', () => {
        const first = grid.firstElementChild;
        if (!first) return;
        const style = getComputedStyle(grid);
        const stride = first.getBoundingClientRect().width + (parseFloat(style.columnGap) || 0);
        const visible = matchMedia('(max-width:989px)').matches ? 2 : 5;
        const current = Math.round(grid.scrollLeft / stride);
        const left = Math.max(0, Math.min(grid.scrollWidth - grid.clientWidth, (current + direction * visible) * stride));
        grid.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      });
      controls.append(button); return button;
    });
    const update = () => {
      // Keep all products in one horizontally scrollable row.
      Array.from(grid.children).forEach((card, index) => {
        card.style.gridColumn = String(index + 1);
        card.style.gridRow = '1';
      });
      buttons[0].disabled = grid.scrollLeft <= 1;
      buttons[1].disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
    };
    grid.addEventListener('scroll', update, { passive: true });
    const observer = new ResizeObserver(update); observer.observe(grid);
    header.append(controls); group.append(header, grid);
    const footer = document.createElement('div'); footer.className = 'rr-model-footer';
    const all = document.createElement('a'); all.textContent = section.dataset.all || 'View all'; all.href = `${window.Shopify?.routes?.root || '/'}pages/${pages[tag]}`; all.setAttribute('aria-label', `${all.textContent}: Tesla ${modelNames[tag]}`); all.append(section.querySelector('[data-diagram-icon]').content.cloneNode(true)); footer.append(all); group.append(footer);
    section.append(group); return { group, grid, update, observer };
  }
  async function populate(section) {
    if (section.dataset.loaded) return; section.dataset.loaded = '1';
    if (section.hasAttribute('data-server-rendered')) { hydrate(section); return; }
    const grid = section.querySelector('[data-managed-grid]');
    const byModel = section.dataset.partSection !== 'fasteners';
    const groups = new Map();
    const reveal = () => {
      if (byModel) {
        section.querySelector(':scope > h2').hidden = true; grid.hidden = true;
        section.classList.add('rr-managed-by-model'); section.hidden = !groups.size;
        for (const tag of ['MY', 'MY JUNIPER', 'M3', 'M3 HIGHLAND', 'MX 2015 2021', 'MX 2021 2025', 'MS 2012 2016', 'MS 2016 2021', 'MS 2021 FEB']) {
          const entry = groups.get(tag);
          if (entry) { section.append(entry.group); entry.update(); }
        }
      } else section.hidden = !grid.childElementCount;
    };
    try {
      const response = await fetch(`${api}/featured-parts?section=${encodeURIComponent(section.dataset.partSection || 'featured')}`, { cache: 'no-store' }); if (!response.ok) throw new Error('Featured parts unavailable');
      const data = await response.json();
      const limit = Number(section.dataset.limit || 8);
      const eligible = data.items.filter(item => section.dataset.partSection !== 'fasteners' || /(?:^|[^A-Z0-9])(?:NUT|BOLT|CLIP)(?=$|[^A-Z0-9])/i.test(item.title));
      const bundles = new Map();
      for (const item of eligible) {
        const key = byModel ? item.handle : item.code.trim().toUpperCase();
        if (!bundles.has(key)) bundles.set(key, []);
        if (!bundles.get(key).some(existing => existing.variant_id === item.variant_id)) bundles.get(key).push(item);
      }
      // Bounded prefetch preserves display order without serial network waits.
      const root = window.Shopify?.routes?.root || '/';
      const pending = Array.from(new Set(eligible.map(item => item.handle)));
      const products = new Map();
      const complete = new Map();
      pending.forEach(handle => products.set(handle, new Promise(resolve => complete.set(handle, resolve))));
      const worker = async () => {
        while (pending.length) {
          const handle = pending.shift();
          try {
            const response = await fetch(`${root}products/${encodeURIComponent(handle)}?view=rr-quantity`, { signal: AbortSignal.timeout(10000) });
            if (!response.ok) throw new Error(`Product HTTP ${response.status}`);
            complete.get(handle)(await response.json());
          } catch (e) { console.warn(e); complete.get(handle)(null); }
        }
      };
      const workers = Array.from({ length: Math.min(6, pending.length) }, worker);
      for (const bundle of bundles.values()) {
        if (!byModel && grid.childElementCount >= limit) break;
        const root = window.Shopify?.routes?.root || '/';
        const choices = [];
        for (const item of bundle) {
          try {
            const quantityData = await products.get(item.handle);
            const product = quantityData?.product; if (!product) continue;
            const variant = product.variants.find(v => String(v.id) === item.variant_id.split('/').pop()); if (!variant) continue;
            const normalizedTitle = new DOMParser().parseFromString(item.title, 'text/html').body.textContent.trim();
            const maxQty = Math.max(1, Math.floor(Number(quantityData.max) || 1));
            if (!byModel && choices.some(choice => choice.item.model === item.model && choice.normalizedTitle === normalizedTitle && choice.variant.price === variant.price && choice.variant.available === variant.available && choice.maxQty === maxQty)) continue;
            choices.push({ item, variant, maxQty, normalizedTitle, modelTag: (product.tags || []).find(t => pages[t]) });
          } catch (e) { console.warn(e); }
        }
        if (!choices.length) continue;
        let { item, variant, modelTag, maxQty } = choices[0];
        let targetGrid = grid;
        if (byModel) {
          if (!modelTag) continue;
          if (!groups.has(modelTag)) groups.set(modelTag, modelGroup(section, modelTag));
          targetGrid = groups.get(modelTag).grid;
          if (targetGrid.childElementCount >= limit) continue;
        }
        const card = document.createElement('article');
        const link = document.createElement('a'); link.className = 'rr-managed-media'; link.href = `${root}products/${item.handle}`;
        const image = document.createElement('img'); image.src = item.url; image.alt = `${item.title} - ${item.code}`; image.loading = 'lazy'; image.width = 480; image.height = 480; link.append(image); card.append(link);
        const badges = document.createElement('div'); badges.className = 'rr-managed-badges';
        for (const [kind, text] of [['model', item.model], ['code', item.code]]) { const el = document.createElement('span'); el.className = `rr-managed-${kind}`; el.textContent = text; badges.append(el); } link.append(badges);
        const title = document.createElement('a'); title.className = 'rr-managed-title'; title.href = link.href;
        title.textContent = item.title.endsWith(item.code) ? item.title.slice(0, -item.code.length).replace(/[\s\u2013\u2014-]+$/, '') : item.title; card.append(title);
        const bottom = document.createElement('div'); bottom.className = 'rr-managed-bottom';
        const price = document.createElement('div'); price.className = 'rr-managed-price';
        const currency = window.Shopify?.currency?.active || 'EUR';
        const amount = document.createElement('b'); amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(variant.price / 100);
        const unit = document.createElement('small'); unit.textContent = currency; price.append(amount, unit); bottom.append(price);
        let modelSelect;
        if (choices.length > 1) {
          const label = document.createElement('label'); label.className = 'rr-managed-choice'; label.textContent = 'Model';
          modelSelect = document.createElement('select'); modelSelect.setAttribute('aria-label', `Model for ${item.code}`);
          choices.forEach((choice, index) => {
            const option = document.createElement('option'); option.value = String(index);
            const repeatedModel = choices.filter(c => c.item.model === choice.item.model).length > 1;
            option.textContent = (modelNames[choice.modelTag] || choice.item.model) + (repeatedModel ? ` - ${new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(choice.variant.price / 100)}` : ''); modelSelect.append(option);
          });
          label.append(modelSelect); bottom.prepend(label);
        }
        const actions = document.createElement('div'); actions.className = 'rr-managed-actions';
        const add = document.createElement('button'); add.type = 'button'; add.textContent = section.dataset.add || 'Add to cart'; add.disabled = !variant.available;
        const cartIcon = section.querySelector('[data-cart-icon]'); if (cartIcon) add.prepend(cartIcon.content.cloneNode(true));
        const originalButton = Array.from(add.childNodes).map(n => n.cloneNode(true));
        add.setAttribute('aria-live', 'polite');
        let feedbackTimer;
        const resetFeedback = () => { clearTimeout(feedbackTimer); add.classList.remove('rr-cart-success', 'rr-cart-error'); add.replaceChildren(...originalButton.map(n => n.cloneNode(true))); add.removeAttribute('title'); };
        const feedback = (ok, detail) => {
          resetFeedback(); add.classList.add(ok ? 'rr-cart-success' : 'rr-cart-error');
          add.textContent = feedbackText[ok ? 0 : 1];
          if (detail) add.title = detail;
          feedbackTimer = setTimeout(resetFeedback, 1800);
        };
        add.addEventListener('click', async () => {
          if (window.Shopify?.country === 'GB') { feedback(false); return; }
          const selectedQuantity = maxQty > 1 ? await chooseQuantity(section, item.code, maxQty, add) : 1;
          if (selectedQuantity === null) return;
          resetFeedback();
          add.disabled = true;
          if (modelSelect) modelSelect.disabled = true;
          try { const r = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variant.id, quantity: selectedQuantity }] }) }); const d = await r.json(); if (!r.ok) throw new Error(d.description || section.dataset.error); feedback(true); } catch(e) { feedback(false, e.message); } finally { add.disabled = !variant.available; if (modelSelect) modelSelect.disabled = false; }
        });
        actions.append(add);
        const view = document.createElement('a'); view.textContent = diagramLabel();
        const diagramIcon = section.querySelector('[data-diagram-icon]'); if (diagramIcon) view.append(diagramIcon.content.cloneNode(true));
        view.href = modelTag ? `${root}pages/${pages[modelTag]}?ai_part=${encodeURIComponent(item.code)}` : `${root}pages/parts-catalog-europe?q=${encodeURIComponent(item.code)}`;
        modelSelect?.addEventListener('change', () => {
          ({ item, variant, modelTag, maxQty } = choices[Number(modelSelect.value)]);
          resetFeedback();
          link.href = `${root}products/${item.handle}`; title.href = link.href;
          title.textContent = item.title.endsWith(item.code) ? item.title.slice(0, -item.code.length).replace(/[\s\u2013\u2014-]+$/, '') : item.title;
          image.src = item.url; image.alt = `${item.title} - ${item.code}`;
          badges.querySelector('.rr-managed-model').textContent = item.model;
          amount.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(variant.price / 100);
          add.disabled = !variant.available;
          view.href = modelTag ? `${root}pages/${pages[modelTag]}?ai_part=${encodeURIComponent(item.code)}` : `${root}pages/parts-catalog-europe?q=${encodeURIComponent(item.code)}`;
        });
        actions.append(view); bottom.append(actions); card.append(bottom); targetGrid.append(card);
        reveal();
      }
      await Promise.all(workers);
      reveal();
    } catch (e) { section.hidden = true; console.warn(e); }
  }
  function hydrate(section) {
    section.querySelectorAll('[data-diagram-link] span').forEach(label => { label.textContent = diagramLabel(); });
    section.querySelectorAll('.rr-model-group').forEach(group => {
      const grid = group.querySelector('.rr-model-carousel');
      const buttons = group.querySelectorAll('.rr-model-controls button');
      const update = () => {
        buttons[0].disabled = grid.scrollLeft <= 1;
        buttons[1].disabled = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 2;
      };
      buttons.forEach((button, index) => button.addEventListener('click', () => {
        const first = grid.firstElementChild; if (!first) return;
        const stride = first.getBoundingClientRect().width + (parseFloat(getComputedStyle(grid).columnGap) || 0);
        const visible = matchMedia('(max-width:989px)').matches ? 2 : 5;
        const target = (Math.round(grid.scrollLeft / stride) + (index ? 1 : -1) * visible) * stride;
        grid.scrollTo({ left: Math.max(0, Math.min(grid.scrollWidth - grid.clientWidth, target)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      grid.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(grid); update();
    });
    section.querySelectorAll('[data-cart-variant]').forEach(add => {
      const original = Array.from(add.childNodes).map(n => n.cloneNode(true));
      let timer;
      const reset = () => { clearTimeout(timer); add.classList.remove('rr-cart-success', 'rr-cart-error'); add.replaceChildren(...original.map(n => n.cloneNode(true))); add.removeAttribute('title'); };
      const feedback = (ok, detail) => {
        reset(); add.classList.add(ok ? 'rr-cart-success' : 'rr-cart-error'); add.textContent = feedbackText[ok ? 0 : 1];
        if (detail) add.title = detail;
        timer = setTimeout(reset, 1800);
      };
      add.addEventListener('click', async () => {
        if (window.Shopify?.country === 'GB') { feedback(false); return; }
        add.disabled = true;
        try {
          const maximum = Math.max(1, Math.floor(Number(add.dataset.max) || 1));
          const quantity = maximum > 1 ? await chooseQuantity(section, add.dataset.code, maximum, add) : 1;
          if (quantity === null) return;
          reset();
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: add.dataset.cartVariant, quantity }] }) });
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || section.dataset.error);
          feedback(true);
        } catch (e) { feedback(false, e.message); }
        finally { add.disabled = false; }
      });
    });
  }
  document.querySelectorAll('[data-managed-parts]').forEach(populate);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-managed-parts]').forEach(populate));
})();
